import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CdkDragDrop} from '@angular/cdk/drag-drop';
import {
  OrganizeDropEvent,
  OrganizeMember,
  OrganizeTeamView,
  RemoveMemberEvent,
  TeamRoleKind,
  toOrganizeDropEvent
} from '../organize-teams.models';

const MIN_MEMBERS_FOR_FEEDBACK = 4;

@Component({
  selector: 'app-organize-teams-team-panel',
  templateUrl: './organize-teams-team-panel.component.html',
  styleUrls: ['./organize-teams-team-panel.component.scss']
})
export class OrganizeTeamsTeamPanelComponent {
  @Input() teams: OrganizeTeamView[] = [];
  @Input() selectedTeam: OrganizeTeamView | null = null;
  @Input() leaders: OrganizeMember[] = [];
  @Input() members: OrganizeMember[] = [];
  @Input() showMembersWarning = false;

  @Output() selectTeam = new EventEmitter<string>();
  @Output() retryTeam = new EventEmitter<string>();
  @Output() dropped = new EventEmitter<OrganizeDropEvent>();
  @Output() remove = new EventEmitter<RemoveMemberEvent>();

  readonly defaultAvatar = 'assets/svg/user-icon.svg';
  readonly minMembersForFeedback = MIN_MEMBERS_FOR_FEEDBACK;
  readonly carouselResponsiveOptions = [
    {breakpoint: '1280px', numVisible: 2, numScroll: 2}
  ];

  onRetry(event: Event, teamUuid: string): void {
    event.stopPropagation();
    this.retryTeam.emit(teamUuid);
  }

  onDropped(event: CdkDragDrop<OrganizeMember[]>): void {
    this.dropped.emit(toOrganizeDropEvent(event));
  }

  onRemove(member: OrganizeMember, role: TeamRoleKind): void {
    this.remove.emit({userUuid: member.userUuid, role});
  }

  trackByUser(index: number, member: OrganizeMember): string {
    return member.userUuid;
  }
}
